<template>
<FilterMe @onSubmit="filters => filterMe(filters)" :filters="filters">
    <template #form="{filters, search}">
        <CRow>
            <CCol col="12" v-if="!filters.store.id">
                <CInput @keyup.enter="search" v-model="filters.store.name" :placeholder="$t('store._')" />
            </CCol>
        </CRow>
    </template>
</FilterMe>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'FilterIt',

    data() {
        return {
            filters: {
                store: {
                    id: this.$route.query.store_id || undefined,
                    name: '',
                },
            },
        }
    },

    methods: {
        ...mapActions({
            fetch: 'commission/fetch',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        filterMe(filters) {
            this.setShowLoading(true)
            this.fetch({
                page: 1,
                ...filters,
            }).then(() => this.setShowLoading(false))
        },
    }
}
</script>
